import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useModalData } from '../../../components/modals/ModalsContext'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text, { Label, Title } from '../../../packages/kiti/components/presentation/Text'
import IconButton from '../../../packages/kiti/components/actions/IconButton'
import Modal from '../../../components/structure/Modal'
import { COLORS } from '@btime/constants'

const HowToMask = () => {
  const { t } = useTranslation('editMasks')
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <>
      <IconButton
        size="small"
        value={t('help')}
        iconLeft="RiQuestionFill"
        iconSize="1rem"
        onClick={() => setIsOpen(true)}
      />
      <Modal open={isOpen} onClose={() => setIsOpen(false)} width="32rem">
        <Grid paddingGutter={0.5} wrap>
          <Title size="h5" bold>
            {t('howToTitle')}
          </Title>
          <Col width="100%" wrapOn="sm">
            <Text size="smal" bold>
              {t('forNumbers')}
            </Text>
            <Text>
              <Label color={COLORS.dark3}>999.999.99-99</Label>
            </Text>
          </Col>
          <Col width="100%" wrapOn="sm">
            <Text size="smal" bold>
              {t('forLetters')}
            </Text>
            <Text>
              <Label color={COLORS.dark3}> AAA/AAA-AA</Label>
            </Text>
          </Col>
          <Col width="100%" wrapOn="sm">
            <Text size="smal" bold>
              {t('forAlphanumeric')}
            </Text>
            <Text>
              <Label color={COLORS.dark3}> SSS#SSSS</Label>
            </Text>
          </Col>
        </Grid>
      </Modal>
    </>
  )
}

const ModalHeader = () => {
  const { t } = useTranslation('editMasks')
  const id = useModalData()
  const isEditing = id > 0
  const context = isEditing && 'edit'
  const title = t('title', { context })

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={10}>
          <Title size="h5" bold>
            {title}
          </Title>
        </Col>
        <Col flex={1} align="right">
          <HowToMask />
        </Col>
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
